package com.essntl.uikit.components.pdfviewer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
fun rememberPdfViewerState(
    url: String
): PdfViewerState {
    return remember(url) {
        PdfViewerState(
            url = url
        )
    }
}

expect class PdfViewerState(
    url: String
) {
    var byteArray: ByteArray
        private set

    var isLoading: Boolean
        private set

    var isFailure: Boolean
        private set
}